import { createBrowserHistory } from 'history';
import * as analytics from 'utils/analytics';

export const history = createBrowserHistory();

history.listen(() => {
  analytics.page();
});
